var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1332",
    d: "M21.1 19.6a.545.545 0 0 1-.42-.18l-4.38-4.38-4.38 4.38a.594.594 0 0 1-.84-.84l4.8-4.8a.58.58 0 0 1 .84 0l4.8 4.8a.58.58 0 0 1 0 .84.545.545 0 0 1-.42.18z",
    transform: "rotate(90 16.9 12.54)",
    style: {
      fill: "#ea7d36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1333",
    d: "M12 24a12 12 0 0 1 0-24 12.192 12.192 0 0 1 7.38 2.52.645.645 0 0 1 .12.84.645.645 0 0 1-.84.12A10.812 10.812 0 1 0 22.8 12a11.21 11.21 0 0 0-1.5-5.52.607.607 0 1 1 1.02-.66A12.578 12.578 0 0 1 24 12a12.035 12.035 0 0 1-12 12z",
    style: {
      fill: "#ea7d36"
    },
    transform: "rotate(90 12 12)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.1670615d3a7efe315868e586e3bbd44f.svg";
export { ForwardRef as ReactComponent };